.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  color: var(--comp-heading-color);
  font-weight: 700;
  margin: 0;
  padding: 0;
}

.h1 {
  font-size: var(--font-size-1);
  line-height: var(--line-size-1);
  margin-bottom: var(--space-medium);
}

.h2 {
  font-size: var(--font-size-2);
  line-height: var(--line-size-2);
  margin-bottom: var(--space-medium);
}

.h3 {
  font-size: var(--font-size-3);
  line-height: var(--line-size-3);
  margin-bottom: var(--space-medium);
}

.h4 {
  font-size: var(--font-size-4);
  line-height: var(--line-size-4);
  margin-bottom: var(--space-small);
}

.h5 {
  font-size: var(--font-size-5);
  line-height: var(--line-size-5);
  margin-bottom: var(--space-small);
}

.h6 {
  font-size: var(--font-size-6);
  line-height: var(--line-size-6);
  margin-bottom: var(--space-small);
}

.center {
  text-align: center;
}

.oneLine {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.autoSpacing {
  margin: calc(3 * var(--space-big)) auto calc(1 * var(--space-big)) auto;
}
